module.exports = __webpack_public_path__ + "img/home_6.3a6bae53.jpg";